<template>
  <div>
    <div class="row q-ma-xl">
      <div class="col">
        <div class="login" v-show="currentView === 'login'">
          <div class="text-h4 q-mb-xl">Sign In</div>
          <template v-if="currentUser">
            <div class="q-my-lg">
              Logging in...
            </div>
          </template>
          <template v-else>
            <Banner v-if="errorMessage" mode="negative">
              {{ errorMessage }}
            </Banner>
            <q-form @submit="onSubmit" class="q-mt-lg q-mb-lg q-gutter-md">
              <q-input
                filled
                v-model.trim="loginForm.email"
                type="text"
                name="loginForm_email"
                id="loginForm_email"
                label="Email"
                :rules="[val => !!val || 'Email is required']"
              />
              <q-input
                filled
                v-model.trim="loginForm.password"
                type="password"
                name="loginForm_password"
                id="loginForm_password"
                label="Password"
                autocomplete="off"
                :rules="[val => !!val || 'Password is required']"
              />
              <div class="q-mt-xl q-mb-xl q-gutter-sm">
                <q-btn
                  :ripple="false"
                  type="submit"
                  push
                  color="primary"
                  label="Sign In"
                ></q-btn>
                <q-btn
                  @click="() => $router.push('register')"
                  :ripple="false"
                  flat
                  no-caps
                  label="Register for an Account"
                ></q-btn>
                <q-btn
                  :ripple="false"
                  flat
                  no-caps
                  @click="setCurrentView('reset-password')"
                  >Forgot Password</q-btn
                >
                <q-btn
                  @click="() => $router.push('terms-of-use')"
                  :ripple="false"
                  flat
                  no-caps
                  label="Terms of Use"
                ></q-btn>
              </div>
            </q-form>
          </template>
        </div>
        <div class="reset-password" v-show="currentView === 'reset-password'">
          <div class="text-h4 q-mb-xl">Reset Password</div>
          <Banner v-if="errorMessage" mode="negative">
            {{ errorMessage }}
          </Banner>
          <Banner v-if="resetPasswordSuccess" mode="positive">
            A link to reset your password has been sent to
            {{ resetPasswordForm.email }}. Be sure to check your spam folder if
            you don't see it soon.
          </Banner>
          <q-form @submit.prevent>
            <q-input
              filled
              v-model.trim="resetPasswordForm.email"
              type="text"
              name="resetPasswordForm_email"
              id="resetPasswordForm_email"
              label="Email"
              :disable="resetPasswordSuccess"
              :rules="[val => !!val || 'Email is required']"
            />
            <div class="q-mt-xl q-mb-xl q-gutter-sm">
              <q-btn
                :ripple="false"
                push
                color="primary"
                @click="resetPassword"
                :disable="resetPasswordSuccess"
                >Submit</q-btn
              >
              <q-btn
                :ripple="false"
                flat
                no-caps
                @click="setCurrentView('login')"
                >Return to Login</q-btn
              >
            </div>
          </q-form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import Banner from "@/components/Banner";
import { logAnalyticsEvent } from "@/apis/analytics-service";
import * as fb from "@/firebaseConfig";

export default {
  name: "Login",
  components: {
    Banner,
  },
  data() {
    return {
      loginForm: {
        email: "",
        password: "",
      },
      resetPasswordForm: {
        email: "",
      },
      resetPasswordSuccess: false,
      currentView: "login",
      errorMessage: "",
    };
  },
  computed: {
    ...mapState(["currentUser"]),
  },
  methods: {
    onSubmit() {
      this.errorMessage = "";
      this.$store.commit("setIsLoading", true);

      return this.login()
        .then(() => {})
        .catch(error => {
          console.error(error);

          this.errorMessage = error.message;
        })
        .finally(() => {
          this.$store.commit("setIsLoading", false);
        });
    },
    login() {
      return fb.auth.signInWithEmailAndPassword(
        this.loginForm.email,
        this.loginForm.password,
      );
    },
    resetPassword() {
      this.$store.commit("setIsLoading", true);
      this.resetPasswordSuccess = false;
      this.errorMessage = "";

      return fb.auth
        .sendPasswordResetEmail(this.resetPasswordForm.email)
        .then(() => {
          this.$store.commit("setIsLoading", false);
          this.resetPasswordSuccess = true;
        })
        .catch(error => {
          console.error(error);
          this.$store.commit("setIsLoading", false);
          this.resetPasswordSuccess = false;
          this.errorMessage = error.message;
        });
    },
    setCurrentView(view) {
      this.currentView = view;
      this.errorMessage = "";
      this.resetPasswordSuccess = false;
    },
  },
  watch: {
    currentUser: {
      handler(newVal) {
        if (newVal) {
          console.debug("currentUser watch", newVal);

          logAnalyticsEvent("login", {
            method: "email",
          });

          this.$store
            .dispatch("appendAuthEvent", "login")
            .then(() => {
              if (this.$route.params.nextUrl) {
                this.$router.push(this.$route.params.nextUrl);
              } else {
                this.$router.push("/");
              }
            })
            .then(() => {
              // TODO: need to do some more resetting here
              this.$store.commit("setFilterInput", []);
            });
        }
      },
      immediate: true,
    },
  },
};
</script>
<style lang="scss" scoped></style>
